export enum TypeQuarkEnum {
  EXPERIENCE = 'EXPERIENCE',
  FORMATION = 'FORMATION',
  SKILL = 'SKILL',
  DOMAIN = 'DOMAIN',
}
